import InfoIcon from 'components/ReusableComponents/Icons/Info'

import styles from './NoEmailSubscriptionWarning.module.scss'

const NoEmailSubscriptionWarning = () => {
  function openChat() {
    window.$crisp.push(['do', 'chat:open'])
    window.$crisp.push([
      'set',
      'message:text',
      ['I would like to enable email campaigns for my property']
    ])
  }

  return (
    <div className={styles.warning}>
      <InfoIcon />
      <span>
        Email campaigns are not enabled for this property.{' '}
        <button className={styles.contactButton} onClick={openChat}>
          Contact your CSM
        </button>{' '}
        to get started.
      </span>
    </div>
  )
}

export default NoEmailSubscriptionWarning
